import { cn } from '@/lib/utils';
import { Activity, Target, Moon } from 'lucide-react';

interface TacticalMacrosProps {
  onMacro: (message: string) => void;
  disabled?: boolean;
}

const macros = [
  { label: 'ANALYZE LAST RUN', icon: Activity, message: 'Analyze my last run and give me feedback on performance' },
  { label: 'ADJUST WEEKLY GOAL', icon: Target, message: 'Adjust my weekly training goal based on recent performance' },
  { label: 'REQUEST REST DAY', icon: Moon, message: 'I need a rest day, please adjust my schedule' },
];

export function TacticalMacros({ onMacro, disabled }: TacticalMacrosProps) {
  return (
    <div className="flex gap-2 px-4 py-2 overflow-x-auto scrollbar-none">
      {macros.map((macro) => (
        <button
          key={macro.label}
          onClick={() => onMacro(macro.message)}
          disabled={disabled}
          className={cn(
            'flex items-center gap-1.5 px-3 py-2 rounded',
            'font-mono text-[10px] uppercase tracking-[0.08em]',
            'whitespace-normal text-left leading-tight min-w-[100px] sm:whitespace-nowrap',
            'border border-white/[0.12] bg-white/[0.03]',
            'text-muted-foreground hover:text-[#00FFC8] hover:border-[#00FFC8]/40',
            'hover:shadow-[0_0_12px_rgba(0,255,200,0.15)]',
            'transition-all duration-200',
            'disabled:opacity-40 disabled:pointer-events-none'
          )}
        >
          <macro.icon className="h-3 w-3 shrink-0" />
          <span>{macro.label}</span>
        </button>
      ))}
    </div>
  );
}
